import { render, staticRenderFns } from "./todo.vue?vue&type=template&id=2ad2387b&scoped=true&"
import script from "./todo.vue?vue&type=script&lang=js&"
export * from "./todo.vue?vue&type=script&lang=js&"
import style0 from "./todo.vue?vue&type=style&index=0&id=2ad2387b&scoped=true&lang=css&"
import style1 from "./todo.vue?vue&type=style&index=1&id=2ad2387b&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad2387b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\myProject\\cbi-site-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ad2387b')) {
      api.createRecord('2ad2387b', component.options)
    } else {
      api.reload('2ad2387b', component.options)
    }
    module.hot.accept("./todo.vue?vue&type=template&id=2ad2387b&scoped=true&", function () {
      api.rerender('2ad2387b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workplace/order/components/todo.vue"
export default component.exports